export default __webpack_public_path__ + "static/parent-app-0f1436a0bafc2ef4542675e187574255.mp4";